// extracted by mini-css-extract-plugin
module.exports = {"section02":"section02_section02__ZqJvv"};